(function () {
  'use strict';

  var config = window.BaviTheme || {};
  var layer = document.querySelector('[data-cart-layer]');
  var cachedCart = config.initialCart || null;
  var cartFetchPromise = null;
  var cartNormalizationPromise = null;
  var lastCartTrigger = null;

  function cartRequest(url, options) {
    var requestOptions = options || {};
    var timeout = requestOptions.timeout || 9000;
    delete requestOptions.timeout;
    if (typeof AbortController === 'undefined') return fetch(url, requestOptions);
    var controller = new AbortController();
    requestOptions.signal = controller.signal;
    var timer = window.setTimeout(function () { controller.abort(); }, timeout);
    return fetch(url, requestOptions).finally(function () { window.clearTimeout(timer); });
  }

  function showCartError() {
    var container = document.querySelector('[data-cart-content]');
    if (!container) return;
    container.innerHTML = '<div class="cart-error" role="alert"><p>Impossible de vérifier le panier.</p><button class="button primary" type="button" data-cart-retry>Actualiser le panier</button></div>';
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>'"]/g, function (char) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[char];
    });
  }

  function money(cents) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {
        style: 'currency', currency: config.currency || 'EUR'
      }).format(Number(cents || 0) / 100);
    } catch (error) {
      return (Number(cents || 0) / 100).toFixed(2).replace('.', ',') + ' €';
    }
  }

  function syncMenuPosition(nav) {
    var header = document.querySelector('.site-header');
    if (!header || !nav) return;
    var bottom = Math.max(0, Math.ceil(header.getBoundingClientRect().bottom));
    nav.style.setProperty('--bavi-menu-top', bottom + 'px');
  }

  function openCart(skipRefresh) {
    if (!layer) return;
    layer.classList.add('is-open');
    layer.setAttribute('aria-hidden', 'false');
    var close = layer.querySelector('[data-cart-close]');
    if (close) close.focus();

    var hasCachedCart = !!cachedCart;
    if (hasCachedCart) renderCart(cachedCart);

    if (!skipRefresh && !hasCachedCart) {
      if (!hasCachedCart) layer.classList.add('is-checking');
      fetchCart()
        .then(function (cart) { renderCart(cart); })
        .catch(function () { if (!hasCachedCart) showCartError(); })
        .finally(function () { layer.classList.remove('is-checking'); });
    }
  }

  function setMenuState(isOpen) {
    var menuButton = document.querySelector('[data-menu-toggle]');
    var nav = document.querySelector('[data-main-nav]');
    if (!menuButton || !nav) return;
    syncMenuPosition(nav);
    menuButton.setAttribute('aria-expanded', String(isOpen));
    menuButton.setAttribute('aria-label', isOpen ? 'Fermer le menu' : 'Ouvrir le menu');
    nav.classList.toggle('is-open', isOpen);
    document.documentElement.classList.toggle('menu-open', isOpen);
  }

  function closeCart() {
    if (!layer) return;
    layer.classList.remove('is-open');
    layer.setAttribute('aria-hidden', 'true');
    if (lastCartTrigger && document.contains(lastCartTrigger)) lastCartTrigger.focus();
    lastCartTrigger = null;
  }

  function updateCounts(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (node) { node.textContent = count; });
    document.querySelectorAll('[data-cart-open]').forEach(function (node) {
      node.setAttribute('aria-label', 'Ouvrir le panier, ' + count + ' article' + (count > 1 ? 's' : ''));
    });
  }

  function showCartLoading() {
    var container = document.querySelector('[data-cart-content]');
    if (!container) return;
    container.innerHTML = '<div class="cart-loading" role="status" aria-live="polite"><strong>Ajouté au panier</strong><p>Actualisation de votre panier…</p></div>';
  }

  function renderCartDiscounts(cart) {
    var applications = Array.isArray(cart && cart.cart_level_discount_applications) ? cart.cart_level_discount_applications : [];
    var totalDiscount = Number(cart && cart.total_discount || 0);
    if (!applications.length && totalDiscount <= 0) return '';
    var rows = applications.map(function (application) {
      var amount = Number(application.total_allocated_amount || 0);
      return '<span>' + escapeHtml(application.title || 'Réduction appliquée') + (amount > 0 ? ' · -' + money(amount) : '') + '</span>';
    }).join('');
    if (!rows && totalDiscount > 0) rows = '<span>Réduction appliquée · -' + money(totalDiscount) + '</span>';
    return '<div class="cart-promo-badge" data-cart-discount><strong>Réduction appliquée</strong>' + rows + '</div>';
  }

  function renderCartTrust() {
    return '<div class="bavi-cart-trust" aria-label="Réassurance et moyens de paiement">' +
      '<div class="bavi-cart-trust__payments" aria-label="Paiement sécurisé">' +
        '<div class="bavi-cart-trust__payment-row">' +
          '<img src="https://cdn.shopify.com/s/files/1/0986/5642/0182/files/visa_30737f80-5ea1-4c96-b62e-faae758b0214.webp?v=1787659129&amp;width=160" alt="Visa" loading="lazy" decoding="async" fetchpriority="low">' +
          '<img src="https://cdn.shopify.com/s/files/1/0986/5642/0182/files/mastercard_e95aac1b-5101-4cd5-be6c-f153fef9b89c.webp?v=1787659129&amp;width=160" alt="Mastercard" loading="lazy" decoding="async" fetchpriority="low">' +
          '<img src="https://cdn.shopify.com/s/files/1/0986/5642/0182/files/apple-pay_bf9bc8a3-5adf-419a-8f7d-7952e19b66a2.webp?v=1787659129&amp;width=160" alt="Apple Pay" loading="lazy" decoding="async" fetchpriority="low">' +
          '<img src="https://cdn.shopify.com/s/files/1/0986/5642/0182/files/google-pay_a1cc296f-9944-4bb4-b0ef-dd83c67c79ad.webp?v=1787659129&amp;width=160" alt="Google Pay" loading="lazy" decoding="async" fetchpriority="low">' +
          '<img src="https://cdn.shopify.com/s/files/1/0986/5642/0182/files/paypal_e4cb8022-a8ba-4eb6-9554-9cb1febde0a4.webp?v=1787659058&amp;width=160" alt="Paypal" loading="lazy" decoding="async" fetchpriority="low">' +
        '</div>' +
      '</div>' +
    '</div>';
  }

  function renderCart(cart) {
    updateCounts(cart.item_count || 0);
    var container = document.querySelector('[data-cart-content]');
    if (!container) return;
    if (!cart.items || !cart.items.length) {
      container.innerHTML = '<div class="empty-cart"><p>Votre prochain rituel n’est pas encore ici.</p><a href="' + escapeHtml(config.rootUrl || '/') + 'collections/all">Découvrir BAVI →</a></div>';
      return;
    }
    var items = cart.items.map(function (item) {
      var imageUrl = item.image ? item.image + (item.image.indexOf('?') >= 0 ? '&' : '?') + 'width=240' : '';
      var image = imageUrl ? '<img src="' + escapeHtml(imageUrl) + '" width="240" height="300" alt="' + escapeHtml(item.product_title) + '" loading="lazy" decoding="async" fetchpriority="low">' : '';
      var variantTitle = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
      var drinksMatch = item.handle === 'focus-flow' && variantTitle.split('/').pop().trim().match(/^(\d+ boissons)$/);
      var formatLabel = drinksMatch ? drinksMatch[1] : variantTitle;
      var formatHtml = formatLabel ? '<p class="cart-item-format">' + escapeHtml(formatLabel) + '</p>' : '';
      return '<article class="cart-item" data-cart-line-key="' + escapeHtml(item.key) + '">' + image + '<div class="cart-item-main"><p class="eyebrow">' + item.quantity + ' article' + (item.quantity > 1 ? 's' : '') + '</p><h3>' + escapeHtml(item.product_title) + '</h3>' + formatHtml + '<p>' + money(item.final_line_price) + '</p>' + '<div class="cart-item-actions"><button type="button" data-cart-line-minus data-line-key="' + escapeHtml(item.key) + '" aria-label="Retirer une unité">−</button><span data-cart-item-quantity aria-live="polite">' + item.quantity + '</span><button type="button" data-cart-line-plus data-line-key="' + escapeHtml(item.key) + '" aria-label="Ajouter une unité">+</button><button type="button" class="cart-item-remove" data-cart-line-remove data-line-key="' + escapeHtml(item.key) + '">Supprimer</button></div></div></article>';
    }).join('');
    container.innerHTML = '<div class="cart-items">' + items + '</div>' + renderCartDiscounts(cart) + '<div class="cart-total"><span>Total</span><strong>' + money(cart.total_price) + '</strong></div>' + '<bavi-shipping-countdown class="bavi-shipping-countdown" aria-live="off"><span class="bavi-shipping-countdown__dot" aria-hidden="true"></span><span><span data-shipping-prefix hidden>Plus que </span><strong data-shipping-clock hidden></strong><span data-shipping-suffix>Commandez aujourd’hui pour une expédition demain.</span></span></bavi-shipping-countdown>' + '<a class="bavi-shipping-countdown__support bavi-cart-support-link" style="display:flex!important;background:transparent!important;color:#184c3f!important;border:0!important;box-shadow:none!important;padding:0!important;border-radius:0!important" href="tel:+33651588240" aria-label="Une question ? Notre service client répond en direct, appeler le 06 51 58 82 40"><span class="bavi-shipping-countdown__support-copy"><span class="bavi-shipping-countdown__support-question">Une question ?</span><span class="bavi-shipping-countdown__support-service">Notre service client <strong>répond en direct</strong> 📱</span></span></a>' + '<a class="button primary full" data-checkout-link href="tel:+33651588240" aria-label="Une question ? Notre service client répond en direct, appeler le 06 51 58 82 40"><span class="bavi-shipping-countdown__support-copy"><span class="bavi-shipping-countdown__support-question">Une question ?</span><span class="bavi-shipping-countdown__support-service">Notre service client <strong>répond en direct</strong> 📱</span></span></a>' + '<a class="button primary full" data-checkout-link href="' + escapeHtml(config.checkoutUrl || ((config.rootUrl || '/') + 'checkout')) + '">Passer commande <span>→</span></a>' + renderCartTrust();
    var supportLinks = document.querySelectorAll('.cart-drawer .bavi-shipping-countdown__support');
    supportLinks.forEach(function (link, index) {
      if (index < supportLinks.length - 1) link.remove();
    });
  }

  function isFullCart(cart) {
    return !!cart && Array.isArray(cart.items) && typeof cart.item_count === 'number' && typeof cart.total_price === 'number';
  }

  function buildOptimisticCart(addResponse) {
    var addedItems = [];
    if (addResponse && Array.isArray(addResponse.items)) {
      addedItems = addResponse.items;
    } else if (addResponse && addResponse.key && (addResponse.id || addResponse.variant_id)) {
      addedItems = [addResponse];
    }
    if (!addedItems.length) return null;

    var baseItems = cachedCart && Array.isArray(cachedCart.items) ? cachedCart.items.slice() : [];
    addedItems.forEach(function (addedItem) {
      var existingIndex = baseItems.findIndex(function (item) { return item.key === addedItem.key; });
      if (existingIndex >= 0) baseItems[existingIndex] = addedItem;
      else baseItems.push(addedItem);
    });

    var itemCount = baseItems.reduce(function (total, item) { return total + Number(item.quantity || 0); }, 0);
    var totalPrice = baseItems.reduce(function (total, item) {
      return total + Number(item.final_line_price != null ? item.final_line_price : item.line_price || 0);
    }, 0);

    return Object.assign({}, cachedCart || {}, {
      items: baseItems,
      item_count: itemCount,
      total_price: totalPrice,
      original_total_price: totalPrice,
      items_subtotal_price: totalPrice
    });
  }

  function fetchCart() {
    if (cartFetchPromise) return cartFetchPromise;
    cartFetchPromise = cartRequest((config.rootUrl || '/') + 'cart.js', { headers: { Accept: 'application/json' }, timeout: 9000 })
      .then(function (response) {
        if (!response.ok) throw new Error('Vérification du panier impossible');
        return response.json();
      })
      .then(function (cart) { cachedCart = cart; return cart; })
      .finally(function () { cartFetchPromise = null; });
    return cartFetchPromise;
  }

  function changeCartLine(lineKey, quantity) {
    return cartRequest((config.cartChangeUrl || '/cart/change') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: quantity }), timeout: 9000
    }).then(function (response) {
      if (!response.ok) throw new Error('Mise à jour du panier impossible');
      return response.json();
    });
  }

  function addVariant(variantId, quantity) {
    return cartRequest((config.cartAddUrl || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: quantity }] }), timeout: 9000
    }).then(function (response) {
      if (!response.ok) throw new Error('Ajout au panier impossible');
      return response.json().then(function (payload) {
        var cart = isFullCart(payload) ? payload : buildOptimisticCart(payload);
        if (cart) cachedCart = cart;
        return cart || payload;
      });
    });
  }

  function updateCartLines(updates) {
    return cartRequest((config.cartUpdateUrl || '/cart/update') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates }), timeout: 9000
    }).then(function (response) {
      if (!response.ok) throw new Error('Mise à jour du panier impossible');
      return response.json();
    }).then(function (cart) { cachedCart = cart; return cart; });
  }

  document.addEventListener('click', function (event) {
    var openButton = event.target.closest('[data-cart-open]');
    var retryButton = event.target.closest('[data-cart-retry]');
    var closeButton = event.target.closest('[data-cart-close]');
    var menuButton = event.target.closest('[data-menu-toggle]');
    var minus = event.target.closest('[data-quantity-minus]');
    var plus = event.target.closest('[data-quantity-plus]');
    var scrollButton = event.target.closest('[data-scroll-to-product]');
    var stickyAddButton = event.target.closest('[data-sticky-add-to-cart]');
    var cartLineMinus = event.target.closest('[data-cart-line-minus]');
    var cartLinePlus = event.target.closest('[data-cart-line-plus]');
    var cartLineRemove = event.target.closest('[data-cart-line-remove]');

    if (openButton) { event.preventDefault(); lastCartTrigger = openButton; openCart(); }
    if (retryButton) { event.preventDefault(); openCart(); }
    if (closeButton) { event.preventDefault(); closeCart(); }
    if (menuButton) {
      var expanded = menuButton.getAttribute('aria-expanded') === 'true';
      setMenuState(!expanded);
    }
    if (event.target.closest('[data-main-nav] a')) {
      setMenuState(false);
    }
    if (cartLineMinus || cartLinePlus || cartLineRemove) {
      event.preventDefault();
      var cartAction = cartLineMinus || cartLinePlus || cartLineRemove;
      var lineKey = cartAction.getAttribute('data-line-key');
      var cartItem = cartAction.closest('[data-cart-line-key]');
      var quantityNode = cartItem && cartItem.querySelector('[data-cart-item-quantity]');
      var currentQuantity = quantityNode ? Number(quantityNode.textContent || 1) : 1;
      var nextQuantity = cartLineRemove ? 0 : Math.max(1, currentQuantity + (cartLinePlus ? 1 : -1));
      layer.classList.add('is-checking');
      changeCartLine(lineKey, nextQuantity)
        .then(function (cart) { cachedCart = cart; renderCart(cart); })
        .catch(function () { showCartError(); })
        .finally(function () { layer.classList.remove('is-checking'); });
    }
    if (minus || plus) {
      var form = event.target.closest('form');
      var input = form && form.querySelector('[data-quantity-input]');
      if (input) input.value = Math.max(Number(input.min || 1), Number(input.value || 1) + (plus ? 1 : -1));
    }
    if (scrollButton) {
      var scrollTarget = document.querySelector('.purchase-panel .bavi-product-form, .inline-purchase .bavi-product-form');
      if (scrollTarget) scrollTarget.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    if (stickyAddButton) {
      event.preventDefault();
      var productForm = document.querySelector('.purchase-panel .bavi-product-form, .inline-purchase .bavi-product-form');
      var productButton = productForm && productForm.querySelector('[data-add-to-cart]');
      if (productForm && productButton && !productButton.disabled) productForm.requestSubmit(productButton);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (!layer || !layer.classList.contains('is-open')) return;
    if (event.key === 'Escape') { closeCart(); return; }
    if (event.key !== 'Tab') return;
    var focusable = Array.from(layer.querySelectorAll('button, a, input, select, textarea, [tabindex]:not([tabindex="-1"])')).filter(function (node) { return !node.disabled && node.offsetParent !== null; });
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });

  document.addEventListener('keydown', function (event) {
    var menuButton = document.querySelector('[data-menu-toggle]');
    var nav = document.querySelector('[data-main-nav]');
    if (!nav || !nav.classList.contains('is-open')) return;
    if (event.key === 'Escape') {
      setMenuState(false);
      if (menuButton) menuButton.focus();
      return;
    }
    if (event.key !== 'Tab') return;
    var focusable = Array.from(nav.querySelectorAll('a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])')).filter(function (node) {
      return !node.disabled && node.offsetParent !== null;
    });
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  window.addEventListener('resize', function () {
    var nav = document.querySelector('[data-main-nav]');
    if (nav && nav.classList.contains('is-open')) syncMenuPosition(nav);
  });

  document.querySelectorAll('[data-variant-select]').forEach(function (select) {
    select.addEventListener('change', function () {
      var option = select.options[select.selectedIndex];
      var form = select.closest('form');
      var button = form && form.querySelector('[data-add-to-cart]');
      document.querySelectorAll('[data-product-price], [data-button-price]').forEach(function (node) { node.textContent = option.dataset.price || ''; });
      document.querySelectorAll('[data-compare-price]').forEach(function (node) {
        node.textContent = option.dataset.comparePrice || '';
        node.hidden = !option.dataset.comparePrice;
      });
      document.querySelectorAll('[data-unit-price]').forEach(function (node) {
        var priceMatch = (option.dataset.price || '').replace(/\s/g, '').replace(',', '.').match(/-?\d+(?:\.\d+)?/);
        node.textContent = priceMatch ? (parseFloat(priceMatch[0]) / 30).toFixed(2).replace('.', ',') + ' € / stick' : (option.dataset.unitPrice || '');
      });
      if (button) {
        var available = option.dataset.available === 'true';
        button.disabled = !available;
        if (available) button.innerHTML = 'Commander <span>→</span>';
        else button.textContent = 'Épuisé';
      }
      normalizeEuroDecimals(document);
    });
  });

  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (event) {
      if (event.submitter && !event.submitter.matches('[data-add-to-cart]')) return;
      event.preventDefault();
      var button = form.querySelector('[data-add-to-cart]');
      var original = button ? button.innerHTML : '';
      var formData = new FormData(form);
      var variantId = formData.get('id');
      if (!variantId) {
        var selectedOffer = form.querySelector('[data-v2-offer].is-selected');
        var selectedVariantId = selectedOffer && selectedOffer.getAttribute('data-variant-id');
        if (selectedVariantId) {
          formData.set('id', selectedVariantId);
          var variantInput = form.querySelector('[data-v2-variant-id]');
          if (variantInput) variantInput.value = selectedVariantId;
          variantId = selectedVariantId;
        }
      }
      var requestedQuantity = Math.max(1, Math.min(6, parseInt(formData.get('quantity') || '1', 10) || 1));
      formData.set('quantity', String(requestedQuantity));
      if (button) { button.disabled = true; button.textContent = 'Ajout en cours…'; }
      cartRequest((config.cartAddUrl || '/cart/add') + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: formData, timeout: 9000 })
        .then(function (response) {
          return response.json().then(function (body) {
            if (!response.ok) {
              var description = body && body.description || '';
              if (response.status === 400 && /section/i.test(description)) return fetchCart();
              throw new Error(description || 'Ajout impossible');
            }
            return body;
          });
        })
        .then(function (addResponse) {
          lastCartTrigger = button || form.querySelector('[data-add-to-cart]');
          openCart(true);

          var cart = isFullCart(addResponse) ? addResponse : buildOptimisticCart(addResponse);
          if (cart) {
            cachedCart = cart;
            renderCart(cart);
            return cart;
          }

          // /cart/add.js can return a single line item instead of { items: [...] }.
          // Only use /cart.js when the response is genuinely not interpretable.
          return fetchCart();
        })
        .then(function (cart) { if (isFullCart(cart)) { cachedCart = cart; renderCart(cart); } })
        .catch(function (error) {
          var status = form.querySelector('[data-form-message]');
          if (!status) { status = document.createElement('p'); status.className = 'form-message'; status.setAttribute('role', 'alert'); status.dataset.formMessage = ''; form.appendChild(status); }
          status.textContent = error.message;
        })
        .finally(function () { if (button) { button.disabled = false; button.innerHTML = original; } });
    });
  });

  function normalizeEuroDecimals(root) {
    root.querySelectorAll('[data-product-price], [data-button-price], [data-compare-price], [data-unit-price], .product-closing > div > p:not(.eyebrow)').forEach(function (node) {
      node.textContent = node.textContent
        .replace(/(\d+),(\d)(?=\s*€)/g, '$1,$20')
        .replace(/(^|[^,\d])(\d+)(?=\s*€)/g, '$1$2,00');
    });
  }
  normalizeEuroDecimals(document);

  if (document.querySelector('.cart-page')) {
    document.querySelectorAll('.cart-page input[name="updates[]"]').forEach(function (input) {
      input.addEventListener('change', function () {
        var form = input.closest('form');
        if (!form || input.dataset.updating === 'true') return;
        input.dataset.updating = 'true';
        input.setAttribute('aria-busy', 'true');
        cartRequest((config.cartUpdateUrl || '/cart/update') + '.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form), timeout: 9000
        }).then(function (response) {
          if (!response.ok) throw new Error('Mise à jour du panier impossible');
          return response.json();
        }).then(function (cart) {
          cachedCart = cart;
          refreshCartPage(cart);
        }).catch(function () {
          input.removeAttribute('aria-busy');
          input.dataset.updating = 'false';
        });
      });
    });
  }

  function refreshCartPage(cart) {
    var page = document.querySelector('[data-cart-page]');
    if (!page) return;
    var items = cart && cart.items || [];
    if (!items.length) {
      page.innerHTML = '<p class="eyebrow">Votre sélection</p><h1>Votre panier</h1><p>Votre prochain rituel n’est pas encore ici.</p><a class="button primary" href="' + escapeHtml(config.rootUrl || '/') + 'collections/all">Découvrir les produits <span>→</span></a>';
      return;
    }
    var rows = Array.from(page.querySelectorAll('[data-cart-line-key]'));
    var rowsByKey = {};
    rows.forEach(function (row) {
      rowsByKey[row.getAttribute('data-cart-line-key')] = row;
      row.hidden = true;
    });
    items.forEach(function (item) {
      var row = rowsByKey[item.key];
      if (!row) return;
      var input = row.querySelector('input[name="updates[]"]');
      if (input) input.value = item.quantity;
      var linePrice = row.querySelector('[data-cart-line-price]');
      if (linePrice) linePrice.textContent = money(item.final_line_price);
      row.hidden = false;
    });
    var discountHost = page.querySelector('[data-cart-discount]');
    if (discountHost) discountHost.outerHTML = renderCartDiscounts(cart);
    var total = page.querySelector('[data-cart-total]');
    if (total) total.textContent = money(cart.total_price);
  }

  var sticky = document.querySelector('[data-mobile-sticky]');
  if (sticky) {
    var purchaseButton = document.querySelector('.purchase-panel [data-add-to-cart]');
    var stickyFrame = null;
    var updateSticky = function () {
      if (stickyFrame !== null) return;
      stickyFrame = window.requestAnimationFrame(function () {
        var showSticky = false;
        if (purchaseButton) {
          var rect = purchaseButton.getBoundingClientRect();
          showSticky = rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) * 0.9;
        }
        sticky.classList.toggle('is-visible', showSticky);
        stickyFrame = null;
      });
    };
    window.addEventListener('scroll', updateSticky, { passive: true });
    window.addEventListener('resize', updateSticky);
    document.addEventListener('focusin', function (event) {
      if (event.target.matches('input, select, textarea')) sticky.classList.remove('is-visible');
    });
    updateSticky();
  }
})();

/* Native-media product gallery for the active product-main section. */
(function () {
  'use strict';

  function initGallery(root) {
    if (!root || root.dataset.galleryReady === 'true') return;

    var frame = root.querySelector('[data-gallery-frame]');
    var main = root.querySelector('[data-gallery-main]');
    var mainPrev = root.querySelector('[data-gallery-main-prev]');
    var mainNext = root.querySelector('[data-gallery-main-next]');
    var thumbs = Array.from(root.querySelectorAll('[data-gallery-thumb]'));
    var mobileTrack = root.querySelector('[data-gallery-mobile-track]');
    var mobileSlides = Array.from(root.querySelectorAll('[data-gallery-mobile-slide]'));
    var mobileDots = Array.from(root.querySelectorAll('[data-gallery-mobile-dot]'));
    var mobilePrev = root.querySelector('[data-gallery-mobile-prev]');
    var mobileNext = root.querySelector('[data-gallery-mobile-next]');
    var mobileCount = root.querySelector('[data-gallery-mobile-count]');
    var viewer = root.querySelector('[data-gallery-viewer]');
    var viewerImage = root.querySelector('[data-gallery-viewer-image]');
    var viewerCaption = root.querySelector('[data-gallery-viewer-caption]');
    var viewerCount = root.querySelector('[data-gallery-viewer-count]');
    var viewerClose = root.querySelector('[data-gallery-close]');
    var viewerPrev = root.querySelector('[data-gallery-prev]');
    var viewerNext = root.querySelector('[data-gallery-next]');

    if (!frame || !main || !thumbs.length) return;
    root.dataset.galleryReady = 'true';

    var activeIndex = Math.max(0, thumbs.findIndex(function (thumb) {
      return thumb.classList.contains('is-active');
    }));
    var lastFocused = null;
    var mobileScrollFrame = 0;

    function updateMobileControls() {
      mobileDots.forEach(function (dot, index) {
        var active = index === activeIndex;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', String(active));
      });
      if (mobileCount) {
        mobileCount.textContent = String(activeIndex + 1).padStart(2, '0') + ' / ' + String(thumbs.length).padStart(2, '0');
      }
    }

    function scrollMobile(index, behavior) {
      if (!mobileTrack || !mobileSlides[index]) return;
      var left = mobileSlides[index].offsetLeft;
      if (typeof mobileTrack.scrollTo === 'function') {
        mobileTrack.scrollTo({ left: left, behavior: behavior || 'smooth' });
      } else {
        mobileTrack.scrollLeft = left;
      }
    }

    function hydrateMobileImage(slide) {
      var image = slide && slide.querySelector('[data-gallery-deferred-image]');
      if (!image) return;
      if (image.dataset.srcset) image.srcset = image.dataset.srcset;
      if (image.dataset.sizes) image.sizes = image.dataset.sizes;
      if (image.dataset.src) image.src = image.dataset.src;
      image.removeAttribute('data-src');
      image.removeAttribute('data-srcset');
      image.removeAttribute('data-sizes');
      image.removeAttribute('data-gallery-deferred-image');
    }

    function renderViewer() {
      var thumb = thumbs[activeIndex];
      if (!thumb || !viewerImage) return;
      viewerImage.src = thumb.dataset.galleryViewerSrc || thumb.dataset.src || main.src;
      viewerImage.alt = thumb.dataset.alt || main.alt || '';
      if (viewerCaption) viewerCaption.textContent = viewerImage.alt;
      if (viewerCount) viewerCount.textContent = String(activeIndex + 1).padStart(2, '0') + ' / ' + String(thumbs.length).padStart(2, '0');
    }

    function select(index, options) {
      activeIndex = (index + thumbs.length) % thumbs.length;
      hydrateMobileImage(mobileSlides[activeIndex]);
      var thumb = thumbs[activeIndex];
      main.src = thumb.dataset.src || main.src;
      if (thumb.dataset.srcset) main.srcset = thumb.dataset.srcset;
      main.alt = thumb.dataset.alt || '';
      thumbs.forEach(function (item, itemIndex) {
        var active = itemIndex === activeIndex;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', String(active));
      });
      updateMobileControls();
      if (!(options && options.scrollMobile === false)) {
        var targetIndex = activeIndex;
        (window.requestAnimationFrame || function (callback) { window.setTimeout(callback, 0); })(function () {
          if (targetIndex === activeIndex) scrollMobile(targetIndex, 'smooth');
        });
      }
      if (viewer && viewer.open) renderViewer();
      var count = root.querySelector('[data-gallery-count]');
      if (count) count.textContent = String(activeIndex + 1).padStart(2, '0') + ' / ' + String(thumbs.length).padStart(2, '0');
    }

    function closeViewer() {
      if (!viewer) return;
      if (viewer.open && typeof viewer.close === 'function') viewer.close();
      else viewer.removeAttribute('open');
      document.documentElement.classList.remove('bavi-gallery-viewer-open');
      if (lastFocused) lastFocused.focus({ preventScroll: true });
    }

    function openViewer() {
      if (!viewer) return;
      lastFocused = document.activeElement;
      renderViewer();
      if (typeof viewer.showModal === 'function') viewer.showModal();
      else viewer.setAttribute('open', '');
      document.documentElement.classList.add('bavi-gallery-viewer-open');
      if (viewerClose) viewerClose.focus({ preventScroll: true });
    }

    thumbs.forEach(function (thumb, index) {
      thumb.addEventListener('click', function () { select(index); });
    });
    mobileDots.forEach(function (dot, index) {
      dot.addEventListener('click', function () { select(index); });
    });
    if (mobilePrev) mobilePrev.addEventListener('click', function () { select(activeIndex - 1); });
    if (mobileNext) mobileNext.addEventListener('click', function () { select(activeIndex + 1); });
    if (mainPrev) mainPrev.addEventListener('click', function () { select(activeIndex - 1); });
    if (mainNext) mainNext.addEventListener('click', function () { select(activeIndex + 1); });

    if (mobileTrack && mobileSlides.length) {
      mobileTrack.addEventListener('scroll', function () {
        if (mobileScrollFrame) return;
        mobileScrollFrame = window.requestAnimationFrame(function () {
          mobileScrollFrame = 0;
          var width = mobileTrack.clientWidth || 1;
          var index = Math.max(0, Math.min(thumbs.length - 1, Math.round(mobileTrack.scrollLeft / width)));
          if (index !== activeIndex) select(index, { scrollMobile: false });
          else updateMobileControls();
        });
      }, { passive: true });
      window.requestAnimationFrame(function () { scrollMobile(activeIndex, 'auto'); });
      window.addEventListener('resize', function () { scrollMobile(activeIndex, 'auto'); });
    }

    var openButton = root.querySelector('[data-gallery-open]');
    if (openButton) openButton.addEventListener('click', openViewer);
    if (viewerClose) viewerClose.addEventListener('click', closeViewer);
    if (viewerPrev) viewerPrev.addEventListener('click', function () { select(activeIndex - 1); });
    if (viewerNext) viewerNext.addEventListener('click', function () { select(activeIndex + 1); });

    /* Touch navigation in the enlarged viewer: horizontal swipes change image;
       a short tap on the image closes the viewer. */
    if (viewerImage) {
      var viewerStartX = 0;
      var viewerStartY = 0;
      var viewerMoved = false;
      viewerImage.addEventListener('pointerdown', function (event) {
        viewerStartX = event.clientX;
        viewerStartY = event.clientY;
        viewerMoved = false;
      }, { passive: true });
      viewerImage.addEventListener('pointerup', function (event) {
        var dx = event.clientX - viewerStartX;
        var dy = event.clientY - viewerStartY;
        viewerMoved = Math.abs(dx) >= 42 && Math.abs(dx) > Math.abs(dy) * 1.15;
        if (viewerMoved) {
          event.preventDefault();
          select(activeIndex + (dx < 0 ? 1 : -1));
        } else {
          closeViewer();
        }
      });
      viewerImage.addEventListener('click', function () {
        if (!viewerMoved) closeViewer();
        viewerMoved = false;
      });
    }
    if (viewer) viewer.addEventListener('click', function (event) {
      if (event.target === viewer) closeViewer();
    });
    if (viewer) viewer.addEventListener('close', function () {
      document.documentElement.classList.remove('bavi-gallery-viewer-open');
      if (lastFocused) lastFocused.focus({ preventScroll: true });
    });

    frame.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') { event.preventDefault(); select(activeIndex - 1); }
      if (event.key === 'ArrowRight') { event.preventDefault(); select(activeIndex + 1); }
      if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); openViewer(); }
    });

    if (!mobileTrack) {
      var sx = 0;
      var sy = 0;
      function startSwipe(x, y) { sx = x; sy = y; }
      function endSwipe(x, y) {
        var dx = x - sx;
        var dy = y - sy;
        if (Math.abs(dx) < 42 || Math.abs(dx) < Math.abs(dy) * 1.15) return;
        select(activeIndex + (dx < 0 ? 1 : -1));
      }
      if ('PointerEvent' in window) {
        frame.addEventListener('pointerdown', function (event) { startSwipe(event.clientX, event.clientY); });
        frame.addEventListener('pointerup', function (event) { endSwipe(event.clientX, event.clientY); });
      } else {
        frame.addEventListener('touchstart', function (event) {
          var touch = event.changedTouches[0];
          startSwipe(touch.clientX, touch.clientY);
        }, { passive: true });
        frame.addEventListener('touchend', function (event) {
          var touch = event.changedTouches[0];
          endSwipe(touch.clientX, touch.clientY);
        }, { passive: true });
      }
    }

    hydrateMobileImage(mobileSlides[activeIndex]);
    updateMobileControls();
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-product-gallery]').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();

/* Mobile editorial carousels. */
(function () {
  'use strict';

  function enhanceMobileCarousels(root) {
    var scope = root || document;
    var tracks = scope.querySelectorAll('.moment-grid, .day-grid, .press-logos-grid, .science-benefit-grid');

    tracks.forEach(function (track) {
      if (track.dataset.mobileCarouselReady === 'true') return;
      track.dataset.mobileCarouselReady = 'true';

      var nav = document.createElement('div');
      nav.className = 'mobile-carousel-nav';
      var hintMarkup = track.hasAttribute('data-carousel-no-hint') ? '' : '<p class="mobile-carousel-hint">' + (track.dataset.carouselHint || 'Balayez pour voir les 3 images') + '</p>';
      nav.innerHTML = hintMarkup +
        '<div class="mobile-carousel-buttons">' +
        '<button class="mobile-carousel-button" type="button" data-carousel-prev aria-label="Image précédente">←</button>' +
        '<button class="mobile-carousel-button" type="button" data-carousel-next aria-label="Image suivante">→</button>' +
        '</div>';

      track.parentNode.insertBefore(nav, track);

      var previous = nav.querySelector('[data-carousel-prev]');
      var next = nav.querySelector('[data-carousel-next]');

      function stepSize() {
        var firstCard = track.firstElementChild;
        if (!firstCard) return track.clientWidth;
        var gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
        return firstCard.getBoundingClientRect().width + gap;
      }

      function updateButtons() {
        var edgeTolerance = 8;
        var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth - edgeTolerance);
        previous.disabled = track.scrollLeft <= edgeTolerance;
        next.disabled = track.scrollLeft >= maxScroll;
      }

      previous.addEventListener('click', function () {
        track.scrollBy({ left: -stepSize(), behavior: 'smooth' });
      });

      next.addEventListener('click', function () {
        track.scrollBy({ left: stepSize(), behavior: 'smooth' });
      });

      track.addEventListener('scroll', updateButtons, { passive: true });
      window.addEventListener('resize', updateButtons);
      updateButtons();
    });
  }

  function scheduleMobileCarouselEnhancement(root) {
    var run = function () { enhanceMobileCarousels(root); };
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(run, { timeout: 1200 });
    } else {
      window.setTimeout(run, 300);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scheduleMobileCarouselEnhancement(document);
    });
  } else {
    scheduleMobileCarouselEnhancement(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    scheduleMobileCarouselEnhancement(event.target);
  });
})();

/* Start non-hero images slightly before they enter the viewport. This keeps
   the native lazy-loading behaviour while avoiding visible image pop-in on
   fast mobile scrolls. Hero images remain the only high-priority resources. */
(function () {
  'use strict';
  if (!('IntersectionObserver' in window)) return;
  var observed = 'data-bavi-nearby-image';
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var image = entry.target;
      image.setAttribute('fetchpriority', 'low');
      observer.unobserve(image);
    });
  }, { rootMargin: '700px 0px', threshold: 0.01 });

  function prepare(scope) {
    (scope || document).querySelectorAll('img[loading="lazy"]:not([' + observed + '])').forEach(function (image) {
      image.setAttribute(observed, 'true');
      image.setAttribute('fetchpriority', 'low');
      observer.observe(image);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { prepare(document); }, { once: true });
  else prepare(document);
  document.addEventListener('shopify:section:load', function (event) { prepare(event.target); });
})();
